import { sendEvent } from "./ga4";

/**
 * Sends GA4 platform_redirect from a document that stays open (via opener bridge).
 * @param {string} link - Final external URL (same as decoded link on DelayNavigatePage).
 * @param {Record<string, object>|undefined|null} providersHost - From Redux uiData.providersHost
 * @param {{ section?: string, sectionValue?: string }|undefined|null} ga
 */
export function reportPlatformRedirect(link, providersHost, ga) {

    if (!link)
        return;

    let hostName;
    try {
        hostName = providersHost && Object.keys(providersHost).find((key) => link.includes(key));
    }
    catch (er) {
        console.error(er);
    }
    finally {
        if (!hostName) {
            try {
                hostName = new URL(link).hostname;
            }
            catch (e) {
                console.error(e);
                return;
            }
        }
    }

    const gaParams = ga?.section ?
        { section: ga.section, "section-value": ga.sectionValue || null }
        :
        {};

    sendEvent("platform_redirect", {
        url: link,
        platform: providersHost?.[hostName]?.platform || hostName,
        platform_name: providersHost?.[hostName]?.platform_name || hostName,
        platform_host: hostName,
        platform_link: link,
        ...gaParams,
    });
}
